<template>
  <div
   infinite-scroll-disabled="loading"
   infinite-scroll-distance="10"
   class="dishData" :class="{paddingBot:classJudge === true}">
    <div class="headerTitle">
      <div class="headerDescribe">
        <img class="dishImg" src='~common/image/dish.png'>
        <span class="titleSpan">菜品销售数据</span>
      </div>
      <data-header @select-resturantId ='changeResturantId'></data-header>
    </div>
    <!-- <div id="dishDataDateSelect"><date-select @select-date = 'getSelectDate'></date-select></div> -->
    
    <div class="wrap_tit">
      <div class="lineBackground"></div>
      <div id="dishDataDateSelect"><date-select @select-date = 'getSelectDate' :dataTimeMenu='dayMenu'></date-select></div> 
      <div class="tit">
        <span class="widthOne borderRight">菜品名称</span>
        <span class="aline"></span>
        <span class="widthTwo borderRight">销售数量</span>
        <span class="aline"></span>
        <span class="widthThree borderRight">销售金额</span>
        <span class="aline"></span>
        <span class="widthFour" @click="changeImage">排名</span>
        <span class="trangle"  @click="changeImage">
          <img src="~common/image/Download.png" alt="" v-if="upDown === true">
          <img src="~common/image/Download拷贝.png" alt="" v-else-if="upDown === false">
        </span>
      </div>
    </div>
    <div class="content">
      <div class="noData" v-show="lists.length === 0">
        <span>无数据......</span>
      </div>
      <div v-for="(item,index) in lists" :class="[ {'numberOne': index==0}, {'numberTwo': index==1}, {'numberThree': index==2}]" :key="index">
        <span class="widthOne marginRight overHidden">{{item.foodName}}</span>
        <span class="widthTwo marginRight overHidden">{{item.detailCount}}</span>
        <span class="widthThree marginRight overHidden">{{item.totalPrice}}</span>
        <span class="widthFour" v-if="type === 1">{{index+1}}</span>
        <span class="widthFour" v-else-if="type === 2">{{lists.length-index}}</span>
      </div>
      
      <!-- </div> -->
    </div>
    <div class="updateTimes">（数据更新时间：{{this.serviceTime | capitalize}}）</div>
  </div>  
</template>
<script>
import DataHeader from 'components/dataHeader'
import DateSelect from 'components/dateSelect'
import { MessageBox } from 'mint-ui'
export default {
  data() {
    return {
      upDown: true,
      lists: [],
      type: 1,
      restaurantId: '',
      classJudge: false,
      dayMenu: [{ 'name': '今日数据' }, { 'name': '昨日数据' }, { 'name': '自定义' }],
      start: this.common.formatDate(new Date()),
      end: this.common.formatDate(new Date()),
      serviceTime: 1520840346558
    }
  },
  components: {
    DataHeader,
    DateSelect
  },
  mounted() {
    this.todayOrYesday()
  },
  computed: {
    bbb: function() {
      return this.$store.state.resturantId
    }
  },
  methods: {
    todayOrYesday() {
      if (this.common.localGet('dayFlag') === 1) {  // 昨日数据
        this.start = this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)
        this.end = this.common.formatDate(new Date() - 24 * 60 * 60 * 1000)
      } else if (this.common.localGet('dayFlag') === 0) { // 今日数据
        this.start = this.common.formatDate(new Date())
        this.end = this.common.formatDate(new Date())
      }
      this.getAxiosData(this.start, this.end) // 获取当天数据
    },
    getSelectDate(date) {
      this.start = date[0]
      this.end = date[1]
      this.getAxiosData(this.start, this.end)
    },
    judgeList() {
      if (this.lists.length === 0) {
        this.classJudge = false
      } else {
        this.classJudge = true
      }
    },
    loadMore() {
      this.loading = true
      setTimeout(() => {
        const last = this.list[this.list.length - 1]
        for (let i = 1; i <= 10; i++) {
          this.list.push(last + i)
        }
        this.loading = false
      }, 2500)
    },
    changeImage() {
      this.upDown = !this.upDown
      if (this.type === 1) {
        this.type = 2
      } else {
        this.type = 1
      }
      this.getAxiosData(this.start, this.end)
    },
    getAxiosData(start, end) {
      let resturantId = this.common.getUrlParam('resturantId')
      if (resturantId === null || resturantId === '') {
        resturantId = 112
      }
      const _this = this
      this.$http.get(this.common.url_order + '/analysisFoodSellList', {
        params: {
          restaurantId: _this.bbb,
          type: _this.type,
          userId: _this.common.localGet('loginInfo').userId,
          endTime: end,
          startTime: start,
          merchantId: _this.common.localGet('loginInfo').merchantId,
          openId: _this.common.localGet('openId')
        }
      })
      .then(function(response) {
        console.log(response)
        if (response.data.code === 0) {
          var data = response.data.data
          for (let i = 0; i < data.length; i++) {
            data[i].totalPrice = data[i].totalPrice.toFixed(2)
          }
          _this.lists = data.foolModelList
          _this.serviceTime = data.serviceTime
        } else if (response.data.code === 300008) {  // 取消权限或被迫下线
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              _this.$router.push({ path: '/login' })
            }
          })
        } else {
          MessageBox.confirm('', {
            message: response.data.msg,
            title: '提示',
            confirmButtonText: '确定',
            showCancelButton: false
          }).then(action => {
            if (action === 'confirm') {
              console.log(response.data.msg)
            }
          })
        }
      })
      .catch(function(error) {
        console.log('错误的请求' + error)
      })
    },
    changeResturantId() {
      this.getAxiosData(this.start, this.end)
    }
  },
  watch: {
    '$route': 'getAxiosData',
    'lists': 'judgeList'
  }
}
</script>
<style>
/* @import '../common/css/disData.css'; */
.paddingBot{
padding-bottom:1.8rem;
}
.dishData {
  /* background-color: #fff;
  width: 100%; */
  width: 100%;
  background-color: #f1f2f3;
  padding-top: 1rem;
}
.headerTitle{
  position:fixed;
  top:0;
  left:0;
  z-index: 9;
  width:100%;
  height: 0.9rem;
  line-height: 0.9rem;
  display:flex;
  display: -webkit-flex; 
  justify-content: space-between;
  align-items:center;
  background-color: #ffffff; 
  -moz-box-shadow:0px 6px 0px rgba(171,175,177,.40); -webkit-box-shadow:0px 6px 0px rgba(171,175,177,.40); box-shadow:0px 6px 0px rgba(171,175,177,.40);
}
#dishDataDateSelect{
  /* position: fixed;
  top: 1rem; */
  width: 100%;
}
#dishDataDateSelect .dateComponent .dataSelect .dayBtn{
  background-color: #fff;
  color: #f74d47;
  border: 1px solid #f74d47;
}
#dishDataDateSelect .dateComponent .dataSelect .dayActive{
  background-color: #f74d47;
  color: #ffffff;
  border: 1px solid #f74d47;
}
#dishDataDateSelect .dataSelect{
  position: fixed;
  top: 1rem;
  left: 0;
  background-color: #ffffff;
}
#dishDataDateSelect .mint-datetime-confirm{
  text-align: right;
  padding-right: 0.8rem;
}
.headerDescribe{
  display:flex;
  display: -webkit-flex; 
  align-items:center;
  margin-left: 0.2rem;
}
.titleSpan{
  font-size: 0.28rem;
  font-weight: 600;
  color:#000000;
}
.dishImg{
  width: 0.28rem;
  height: 0.28rem;
  margin-right: 0.1rem;
}
.questionImg{
  width: 0.24rem;
  height: 0.24rem;
  margin-left: 0.08rem;
}
.wrap_tit{
  /* position: fixed;
  top: .9rem;
  left: 0; */
  width: 100%;
  height: 1.4rem;
  /* z-index: 10; */
  /* line-height: 0.6rem; */
}
.lineBackground{
  position: fixed;
  /* z-index: 1; */
  background:#f1f2f3;
  width:100%;
  height:0.1rem;
  top: .9rem;
}
.tit {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  background-color: #f3fbfd;
  position: fixed;
   /* position: relative; */
   /* z-index: 1; */
  top: 1.8rem;
  left: 0;
   /* border-top:0.1rem solid #f0f0f0; */
   
}
.tit .trangle{
  position: absolute;
  content:'';
  top:0;
  right: 0.05rem;
  width:0.16rem;
  height:0.2rem;
  /* background:url("../common/image/Download.png") no-repeat; */
  background-size:contain;
}
.trangle img{
 width:0.16rem;
  height:0.2rem;
}

.tit span {
  display: inline-block;
  float: left;
  text-align: center;
  height: 0.6rem;
  line-height: 0.6rem;
}
.widthOne {
  width: 33%;
}
.widthTwo {
  width: 27%;
}
.widthThree {
  width: 24%;
}
.widthFour {
  width: 15%;
  overflow: initial;
}
.tit .aline {
  border-right: 1px solid #ccc;
  width: 0.01rem;
  height: 0.3rem;
  margin-top: 0.15rem;
}
.content {
  width: 100%;
  /* height: 0.6rem; */
  /* margin-top: 1.5rem; */
}
.content div {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  background:#fff;
  border-bottom:0.01rem solid #f0f0f0;
}
.content div:last-child{
  border:none;
  
}
.content div span {
  display: inline-block;
  float: left;
  text-align: center;
}
.marginRight {
  margin-right: 0.01rem;
}
.content .numberOne {
  background-color: #ffe2e1;
  color: #ff3c00;
  border:none;
}
.content .numberTwo {
  background-color: #fff1e1;
  color: #ad570b;
  border:none;
}
.content .numberThree {
  background-color: #fff8ef;
  color: #6a6b08;
  border:none;
}
.tit .content .noData{
  text-align: center;
}
.tit .content .noData span{
  margin-left: 0.15rem;;
}
.content .noData{
  text-align: center;
}
.content .noData span{
  float:none;
}
.updateTimes{
  font-size: 0.24rem;
  position: fixed;
  bottom: .98rem;
  left: 0;
  width: 100%;
  text-align: center;
  background-color: #f1f2f3;
  height: .9rem;
  line-height: .9rem;
  box-shadow: 0 -1px 10px #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/dishData.vue